import React, { useEffect, useState } from "react";
import SidebarMenu from "./SidebarMenu/SidebarMenu";
import Style from "./LayoutContainer.module.scss";
import SidebarMenuPeyk from "./SidebarMenuPeyk/SidebarMenuPeyk";

const LayoutContainer = (props) => {
  const [project, setProject] = useState(localStorage.getItem("Tab"));
  useEffect(() => {
    if (!localStorage.getItem("Tab")) {
      setProject("food");
      localStorage.setItem("Tab", "food");
    }
  }, []);
  const changeProje = (type) => {
    if (type === 1) {
      setProject("taxi");
      localStorage.setItem("Tab", "taxi");
    }
    if (type === 2) {
      setProject("buy");
      localStorage.setItem("Tab", "buy");
    }
    if (type === 3) {
      setProject("food");
      localStorage.setItem("Tab", "food");
    }
  };
  let content = null;

  if (project=== "taxi") {
    content = <p>تاکسی</p>;
  } else if (project=== "food") {
    content = (
      <>
        <div className={Style.sidebar}>
          <SidebarMenu/>
        </div>
        <div className={Style.childrens}>{props.children}</div>
      </>
    );
  } else if (project=== "buy") {
    content = (
      <>
        <div className={Style.sidebar}>
          <SidebarMenuPeyk/>
        </div>
        <div className={Style.childrens}>{props.children}</div>
      </>
    );
  }
  return (
    <div className={Style.componentHolder}>
      {/* <ul className={Style.projects}>
        <li className={Style.firstLi}>
          <div onClick={() => changeProje(1)}
            className={project==="taxi"? Style.selectedProject: Style.eachProject}
          >مدیریت تاکسی</div>

          <div
            onClick={() => changeProje(2)}
            className={project==="buy"?Style.selectedProject:Style.eachProject
            }
          >مدیریت درخواست پیک</div>

          <div
            onClick={() => changeProje(3)}
            className={project==="food"?Style.selectedProject:Style.eachProject
            }
          >مدیریت فروشگاه و رستوران</div>
        </li>

        <li className={Style.secondLi}>
          <div className={Style.emptyLi}></div>
        </li>

      </ul> */}
      <div className={Style.centerHolder}>
        {/* <div className={Style.sidebar}>
          <SidebarMenu />
        </div> */}
        {content}
        {/* <div className={Style.childrens}>{props.children}</div> */}
      </div>
    </div>
  );
};

export default LayoutContainer;
